import dashboardsRepository from '@/services/varia/dashboardsRepository';
import notificationService from '@/services/notificationService';

export default class Dashboard implements IDashboard {
    public id: string = '';
    public name: string = '';
    public public: boolean = false;
    public owner: string = '';
    public items: IDashboardItem[] = [];

    public saving: boolean = false;
    public loading: boolean = false;

    // CTOR
    constructor(id?: string) {
        if (id) {
            this.init(id);
        }
    }

    // Update
    public async saveChanges() {
        try {
            this.saving = true;
            const dataToSend: IDashboard = new Dashboard();
            Object.assign(dataToSend, this);
            dataToSend.items = JSON.stringify(dataToSend.items);
            await dashboardsRepository.updateAdvanced(dataToSend);
            notificationService.saved();
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.saving = false;
        }
    }

    public async add(value: string) {
        if (!this.items) {
            this.items = [];
        }

        this.items.push({
            itemType: value,
        });
    }

    // Load
    private async init(id: string) {
        try {
            this.loading = true;
            const result = (await dashboardsRepository.getSingle(id)).data;
            result.items = result.items && result.items !== '' ? JSON.parse(result.items as string) : [];
            Object.assign(this, result);
        } catch (err) {
            notificationService.showErrorMessage('Er is iets verkeerd gelopen tijdens het inladen van het dashboard');
        } finally {
            this.loading = false;
        }
    }
}
